import { AbstractControl, ValidatorFn } from '@angular/forms';

import { DateAfterValidatorOptions } from '../model';

export const dateAfterValidator = (
  compareToControlName: string,
  options: DateAfterValidatorOptions = {},
): ValidatorFn => {
  return (control: AbstractControl) => {
    const formGroup = control.parent;
    if (!formGroup) return null;

    const compareTo = formGroup.get(compareToControlName);
    if (!compareTo || !control.value || !compareTo.value) return null;

    const { minimumDifferenceInDays, dateLabel, compareToDateLabel } = options;
    const currentDate = new Date(control.value);
    const compareDate = new Date(compareTo.value);

    let message = $localize`:formError|The end date must be the same as or after the start date@@endDateNotBeforeStartDate:${dateLabel || 'Einddatum'} mag niet vóór de ${compareToDateLabel ? compareToDateLabel.toLowerCase() : 'startdatum'} liggen.`;

    if (minimumDifferenceInDays) {
      compareDate.setDate(compareDate.getDate() + minimumDifferenceInDays);
      const minimumDifferenceInDaysText = `${minimumDifferenceInDays} dag${minimumDifferenceInDays > 1 ? 'en' : ''}`;
      message = $localize`:formError|The end date must be the same as or after the start date@@endDateNotBeforeStartDateWithOffset:${dateLabel || 'Einddatum'} moet minimaal ${minimumDifferenceInDaysText} na de ${compareToDateLabel ? compareToDateLabel.toLowerCase() : 'startdatum'} liggen.`;
    }

    return compareDate <= currentDate
      ? null
      : {
          dateAfter: {
            message,
          },
        };
  };
};
